<template>
  <CModal
    :on-update:show="(val: boolean) => emit('update:show', val)"
    show
    :style="{ backgroundColor: themeVars.base }"
  >
    <CCard aria-modal="true" :bordered="false" class="max-w-[480px]" role="dialog" size="medium">
      <div class="modal-title">
        {{
          initialValues?.name
            ? t('canvasUI.browserApp.upsertFolder.updateTitle')
            : t('canvasUI.browserApp.upsertFolder.createTitle')
        }}
      </div>
      <NForm ref="formRef" class="mt-4 mb-4" :model="form" @submit.prevent="onSubmit">
        <NFormItem
          class="modal-label"
          :label="t('canvasUI.browserApp.upsertFolder.folderName')"
          path="name"
          required
          :rule="{
            required: true,
            message: t('canvasUI.browserApp.upsertFolder.validation.name.required'),
            trigger: ['input', 'blur'],
          }"
        >
          <NInput v-model:value="form.name" placeholder="" />
        </NFormItem>
      </NForm>
      <div class="flex justify-between items-center">
        <CButton @click="emit('update:show', false)">{{ t('canvasUI.common.cancel') }}</CButton>
        <CButton :loading="isLoading" type="primary" @click="onSubmit">
          {{
            initialValues?.name
              ? t('canvasUI.browserApp.upsertFolder.updateBtn')
              : t('canvasUI.browserApp.upsertFolder.createBtn')
          }}
        </CButton>
      </div>
    </CCard>
  </CModal>
</template>

<script setup lang="ts">
import { reactive, onMounted, ref } from 'vue'
import type { FormInst } from 'naive-ui'
import { NForm, NFormItem, NInput } from 'naive-ui'
import { useI18n } from 'vue-i18n'

import CModal from '@lib/components/CModal/CModal.vue'
import CButton from '@lib/components/CButton/CButton.vue'
import CCard from '@lib/components/CCard/CCard.vue'
import useThemeVars from '@lib/composables/useThemeVars'

const props = defineProps<{
  initialValues?: { name: string }
}>()

const emit = defineEmits<{
  'update:show': [show: boolean]
  submit: [name: string]
}>()

const { t } = useI18n()
const isLoading = ref(false)
const formRef = ref<FormInst | null>(null)
const form: { name: string } = reactive({
  name: '',
})

onMounted(() => {
  if (props.initialValues) {
    form.name = props.initialValues.name
  }
})

async function onSubmit() {
  formRef.value?.validate(async (errors) => {
    if (errors?.length) return
    isLoading.value = true
    emit('submit', form.name)
  })
}

const themeVars = useThemeVars()
</script>

<style scoped>
.modal-title {
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.25px;
}

.modal-label {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
}
</style>
